import { Notification } from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'
import styles from './Snackbar.module.css'
import { Typography } from './Typography'

export type SnackbarSize = 'large' | 'middle' | 'small' | 'withButton'

export type SnackbarProps = {
  message: string
  size?: SnackbarSize
  onClose?: () => void
  actionLabel?: string
  onAction?: () => void
}

const SIZE_CLASS: Record<SnackbarSize, string> = {
  large: styles.large,
  middle: styles.middle,
  small: styles.small,
  withButton: styles.withButton,
}

const ICON_SIZE: Record<SnackbarSize, number> = {
  large: 36,
  middle: 32,
  small: 28,
  withButton: 28,
}

function InfoIcon({ size }: { size: number }) {
  return <IconInfoCircle size={size} stroke={1.5} color="white" aria-hidden="true" />
}

export function Snackbar({ message, size = 'large', onClose, actionLabel, onAction }: SnackbarProps) {
  return (
    <Notification
      unstyled
      withBorder={false}
      icon={<InfoIcon size={ICON_SIZE[size]} />}
      onClose={onClose}
      withCloseButton={!!onClose}
      classNames={{
        root: `${styles.root} ${SIZE_CLASS[size]}`,
        icon: styles.icon,
        body: styles.body,
        description: styles.description,
        closeButton: styles.closeButton,
      }}
    >
      {size === 'withButton' ? (
        <div className={styles.withButtonContent}>
          <Typography variant="caption1" component="span" className={styles.messageMultiline}>
            {message}
          </Typography>
          {actionLabel && (
            <button type="button" className={styles.actionButton} onClick={onAction}>
              {actionLabel}
            </button>
          )}
        </div>
      ) : (
        message
      )}
    </Notification>
  )
}
